"use strict";
exports.__esModule = true;
exports.clear = void 0;
var ramda_1 = require("ramda");
var isVoid_1 = require("./isVoid");
var clear = function (obj) {
    return ramda_1.is(Array)(obj)
        ? obj.filter(function (value) { return !isVoid_1.isVoid(value); })
        : ramda_1.pickBy(function (value) { return !isVoid_1.isVoid(value); }, obj);
};
exports.clear = clear;
//# sourceMappingURL=clear.js.map